import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import moment from 'moment'
import ContentService from '../services/content'

export default (props) => (
  <NewsItem>
    <Preview src={props.icon} alt=""/>
    <div>
      <Time>{moment(props.created_at).format('D.M.YYYY')}</Time>
      <Title to={ContentService.generateArticleUrl(props.id)}>{props.name}</Title>
    </div>
  </NewsItem>
)

const NewsItem = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  padding: .5rem 0;
  
  @media all and (max-width: 520px) {
    align-items: flex-start;
  }
`

const Preview = styled.img`
  max-width: 128px;
  border-radius: 5px;
  margin-right: 1rem;
`

const Time = styled.time`
  font-size: .9rem;
  color: #ccc;
`

const Title = styled(Link)`
  display: block;
  font-size: 1.2rem;
  color: ${({theme}) => theme.primary};
  font-weight: 600;
  
  @media all and (max-width: 520px) {
    font-size: 1rem;
  }
`
